<template>
	<div>
		<div class="modal fade" id="CatModal" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<div class="modal-content" style="width: 40%; margin: 0 auto">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE EXAMES DOF
						</h4>
					</div>
					<!-- <div class="modal-body" v-if="!this.data.creationCPF"> -->
					<div class="modal-body">
						<div class="col-sm-12">
							<span>EMPRESA</span>
							<input
								type="text"
								v-model="data.empresa"
								class="form-control"
								placeholder="EMPRESA"
							/>
						</div>

						<div class="col-sm-3">
							<span>FROTA</span>
							<input
								type="text"
								v-model="data.frota"
								class="form-control"
								placeholder="FROTA"
							/>
						</div>

						<div class="col-sm-9">
							<span>NAVIO</span>
							<input
								type="text"
								v-model="data.navio"
								class="form-control"
								placeholder="NAVIO"
							/>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								data-dismiss="modal"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-exams"
								@click="saveShip"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*

id precisa existir para poder ocorrer a criação

*/
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import axios from 'axios';
	import moment from 'moment';

	let reset = {
		id: '',
		empresa: '',
		nome: '',
		colaborador: '',
		cargo: '',
		navio: '',
		frota: '',
		idade: 0,
		tipoDoTeste: '',
		localTeste: '',
		dataTeste: `${new Date().getFullYear()}-${
			new Date().getMonth() + 1 < 10 && 0
		}${new Date().getMonth() + 1}-${new Date().getDate()}T${
			new Date().getHours() < 10 ? 0 : ''
		}${new Date().getHours()}:${
			new Date().getMinutes() <= 10 ? 0 : ''
		}${new Date().getMinutes()}`,
		laboratorio: '',
		parceiro: '',
		dataResultado: `${new Date().getFullYear()}-${
			new Date().getMonth() + 1 < 10 && 0
		}${new Date().getMonth() + 1}-${new Date().getDate()}T${
			new Date().getHours() < 10 ? 0 : ''
		}${new Date().getHours()}:${
			new Date().getMinutes() <= 10 ? 0 : ''
		}${new Date().getMinutes()}`,
		tempoResultado: 0,
		tempoResultadoFormatado: '0 horas',
		resultado: false,
		creationShip: false,
		municipio: '',
		estado: '',
		RG: '',
		CPF: '',
		// newCPF: {

		// },
		// newShip: {
		// 	empresa: "",
		// 	frota:   "",
		// 	navio:   "",
		// },
	};

	// console.log("reset.dataTeste")
	// console.log(reset.dataTeste)
	// console.log("2022-04-26T05:20")

	export default {
		name: 'ChModalExames',
		components: { aBox, aBtn },
		data() {
			return {
				data: clone(reset),
				test: null,
				pessoas: [],
				navios: [],
				estados: null,
				municipios: null,
				tipoTeste: [
					'Antígeno Nasofargeo',
					'Antigeno Nasal',
					'Antigeno Auto Teste',
					'PCR ',
					'PCR Express',
					'PCR Lamp',
					'IGM/IGG Sorologia',
					'IGM/IGG Teste Rápido',
				],

				localDoteste: [
					'A bordo',
					'Base Macaé',
					'Base Rio Sul',
					'RENAVE',
					'MAUÁ',
					'Porto Docas',
					'Girassol',
					'H Guanabar',
					'H Brisa Tropical',
					'H Confort Vitória',
					'N Niteroi',
					'H Paradiso',
					'H Royal Atlantico Macae',
					'h Windhan Barra',
					'Arsenal de Marinha',
					'Porto do Açu',
					'Residencial',
					'Sede Viamed',
					'H Americas Barra',
					'H Dubai Macaé',
					'H Ibis Macaér',
					'H Promenade Barra',
					'H Tullip Inn Campos',
					'Cais de Pesca Angra dos Reis',
					'H W Astúrias',
				],

				laboratory: [
					'Contra Prova',
					'Tommasi',
					'Labor Life',
					'Viamed',
					'Hi Lab',
				],

				parca: ['Viamed', 'Contexto', 'Tommasi', 'Solana'],
			};
		},
		methods: {
			handleTest() {
				const dataTesteFormatada = new Date(this.data.dataTeste);
				const dataResuladoFormatada = new Date(this.data.dataResultado);

				const dataTesteNumerico = Date.parse(dataTesteFormatada);
				const dataResuladoNumerico = Date.parse(dataResuladoFormatada);

				const razao = dataResuladoNumerico - dataTesteNumerico;

				const dias = razao / (1000 * 60 * 60 * 24);

				const minutosTotais = razao / 60000;

				let horas = minutosTotais / 60;

				console.log('horas ', horas);

				const horasFormatadas =
					(razao % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60);

				const restoDosMinutos = (horas - Math.floor(horas)) * 60;

				// const tempoResultado = `${dias.toFixed()} dia${dias.toFixed() == 1 ? "" : "s" }, ${horasFormatadas.toFixed()} hora${horasFormatadas.toFixed()  == 1 ? "" : "s" }, ${restoDosMinutos.toFixed()} minuto${restoDosMinutos.toFixed() == 1 ? "" : "s" } `
				const tempoResultado = `${horas.toFixed()} hora${
					horas.toFixed() == 1 ? '' : 's'
				} `;

				this.data.tempoResultadoFormatado = tempoResultado;
				this.data.tempoResultado = razao;
			},

			handleChangeData() {
				const cpf = this.data.CPF.replace(/[^\w\s]/gi, '');
				console.log(cpf);
				console.log(cpf.length);

				if (cpf.length < 2) return;

				const testParms = {
					pager: {
						page: '0',
						qnt: '50',
					},
					filter: `cpf=${cpf}`,
				};

				WBS.send('private-read-pessoas', testParms, (resp) => {
					if (!resp.data.table[0]) {
						return toastr.error('CPF não cadastrado');
						// toastr.error(resp.msgs[0])
					}

					const tableValues = resp.data.table[0];

					console.log('tableValues');
					console.log(tableValues);

					this.data.empresa = tableValues.empresa;
					this.data.nome = tableValues.nome; //colaborador
					this.data.RG = tableValues.RG;
					this.data.cargo = tableValues.cargo;
				});
			},

			handleToggleCreationCPF() {
				this.data.creationCPF = !this.data.creationCPF;
			},

			handleToggleCreationShip() {
				this.data.creationShip = !this.data.creationShip;
			},

			open(data = null) {
				if (data != null) this.data = clone(data);
				else this.data = clone(reset);
				$('#CatModal').modal('show');
			},
			save() {
				WBS.send('private-save-exams', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$('#CatModal').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});
			},

			saveCpf() {
				WBS.send('private-save-pessoas', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationCPF();
						// $('#CatModal').modal('hide')
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});

				console.log('submit ----------*-------------');
			},

			saveShip() {
				WBS.send('private-save-navios', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.handleToggleCreationShip();
						this.$emit('update');
						$('#CatModal').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});

				console.log('submit ----------*-------------');
			},

			handleLoadNavios() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '50',
					},
					// filter: `cpf=${cpf}`
				};

				WBS.send('private-read-navios', testParms, (resp) => {
					this.navios = resp.data.table;
					console.log(resp.data.table.length);
					const lastNavio = this.navios[this.navios.length - 1];
					this.data.navio = lastNavio.navio;

					console.log(lastNavio.navio);

					console.log(resp.data.table);
				});
			},

			onSelectState() {
				console.log(this.data.estado);
				axios
					.get(
						`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.data.estado}/municipios?orderBy=nome`
					)
					.then((response) => (this.municipios = response.data));
			},
		},

		mounted() {
			axios
				.get(
					'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome'
				)
				.then((response) => (this.estados = response.data));

			this.handleLoadNavios();
		},
	};
</script>

<style>
	span {
		text-transform: uppercase;
	}

	.modal-dialog {
		width: 80% !important;
	}

	.modal-footer__buttons {
		display: flex;
		justify-content: space-between;
	}

	.add-more-section {
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/navio/modal.vue